import { act } from "react-dom/test-utils";
import dateMatcher from "./dateMatcher";
import {
  getLastNdaysLabel as getLabel,
  getLastNdates as getDates,
} from "./getLastNdays";
import {
  branchBasedFeedbackDataFilter,
  getActiveBranchIds1,
  getStaffRegisterbyBid,
} from "./multipleBranch/getActiveBranchId";

/*
phases involved would be 
1st data extration from feedback data. ie staff property and date from feedback.

2nd data reducer to be suitabe for line chart .

3rd step will be to modify reduced data in the formate prescribed by chartj js library
*/

//phase 1
export function extractFeedbackData(data1, numOfDays) {
  //this function accepts two dates and appropriate data between these dates will be returned
  // this data will be array of feedbacks stored in session storage
  //console.log(data1);
  if (data1 == null) return null;

  // we create label for chart here only because getDates function requires num of Days as input.
  // so label is sent to data reducer function which is next stage
  const datesArr = getDates(numOfDays);

  //step 1 we find todays date and date thats numOfDays back.
  let date1 = new Date();
  let date2 = new Date();
  let decrease = date1.getDate() - numOfDays;
  date2.setDate(decrease);

  const data = [];
  data1.forEach((item) => {
    let tdate = item.createdAt;
    let result = dateMatcher(tdate, date2, date1);
    // console.log(result, item.createdAt);
    if (result) {
      // Some feedback entries have no staff object; skip them instead of crashing
      if (item.staff?.rating != undefined)
        data.push({ staff: item.staff, date: item.createdAt.split("T")[0] });
    }
  });
  const output = {
    dates: datesArr,
    data: data,
  };
  //console.log(output);

  return output;
  // format of output
  /**
      const dummyOutput = [
    {
      date: "2024-11-06",
      staff: { id: "1", name: "Rajesh1", rating: 5 },
    },
    {
      date: "2024-11-06",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-06",
      staff: { id: "3", name: "Rajesh3", rating: 5 },
    },
    {
      date: "2024-11-05",
      staff: { id: "1", name: "Rajesh1", rating: 5 },
    },
    {
      date: "2024-11-05",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-05",
      staff: { id: "3", name: "Rajesh3", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "1", name: "Rajesh1", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "3", name: "Rajesh3", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "3", name: "Rajesh3", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "3", name: "Rajesh3", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-04",
      staff: { id: "3", name: "Rajesh3", rating: 5 },
    },
    {
      date: "2024-11-03",
      staff: { id: "1", name: "Rajesh1", rating: 5 },
    },
    {
      date: "2024-11-03",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-03",
      staff: { id: "1", name: "Rajesh1", rating: 5 },
    },
    {
      date: "2024-11-03",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-03",
      staff: { id: "1", name: "Rajesh1", rating: 5 },
    },
    {
      date: "2024-11-03",
      staff: { id: "2", name: "Rajesh2", rating: 5 },
    },
    {
      date: "2024-11-03",
      staff: { id: "3", name: "Rajesh3", rating: 5 },
    },
  ];
   */
}

//Phase 2
// output data should be in this formate
/**
    const dataset = [
    {
        id: "456",
        name: "Ramesh" 
        data: [
    { date: "2024-11-06", count: 10 },
    { date: "2024-11-07", count: 20 },
    { date: "2024-11-08", count: 15 },
    { date: "2024-11-09", count: 25 },
    { date: "2024-11-10", count: 22 },
    { date: "2024-11-11", count: 30 },
    { date: "2024-11-12", count: 28 },
  ]; 
},
{
        id: "457",
        name: "Rajesh" 
        data: [
    { date: "2024-11-06", count: 10 },
    { date: "2024-11-07", count: 20 },
    { date: "2024-11-08", count: 15 },
    { date: "2024-11-09", count: 25 },
    { date: "2024-11-10", count: 22 },
    { date: "2024-11-11", count: 30 },
    { date: "2024-11-12", count: 28 },
  ]; } ]   */

export function reduceExtractedData(inputData, bId) {
  console.log(inputData);
console.log("bId", bId);
  const dates = inputData.dates;
  // label item format "2024-11-06"
console.log("dates", dates);
  // we will need staff info from staff register.
  const staffRegister = getStaffRegisterbyBid(bId);
  console.log("staffRegister", staffRegister);
  if (staffRegister == null || staffRegister.length === 0) return null;
  //console.log(staffRegister);
  // console.log(staffRegister);

  //attempt 2
  //Traveersing in staffRegister for each staff employee
  const reducedData = [];
  // console.log(inputData.data[0]);
  staffRegister?.forEach((staff) => {
    // console.log(staff);
    let name = staff.name;
    let id = staff.id;
    let obj1 = {
      name,
      data: [],
      score: 0,
      frequency: 0,
    };

    let iScore = 0;
    let iFrequency = 0;

    // console.log(label);
    // Traversing  via date
    dates.forEach((date1) => {
      let obj2 = { date: "", count: 0 };
      obj2.date = date1;

      // now we travers through extracted input data
      let count1 = 0;

      inputData.data.forEach((dataItem) => {
        if (dataItem.date == date1) {
          if (dataItem.staff.id == id) {
            count1 += dataItem.staff.rating;
            iScore += dataItem.staff.rating;
            iFrequency++;
          }
        }
      });

      // calculating avgScore from score and frequency
      let avgScore;
      if (iScore == 0) {
        avgScore = 0;
      } else {
        avgScore = Math.round((iScore / iFrequency) * 100) / 100;
      }
      obj2.count = count1;
      obj1.data.push(obj2);
      obj1.score = iScore;
      obj1.avgScore = avgScore;
      obj1.frequency = iFrequency;
    });
    reducedData.push(obj1);
  });

  //console.log(reducedData);
  return reducedData;
}

// phase 3 output data formate below
/**
 * 
 * const data = {
  labels: labels,
  datasets: [
    {
      label: "My First dataset",
      // if NO color is provided it automatically uses colors from colour pallet.
      // backgroundColor: "rgb(109, 109, 109)",
      // borderColor: "rgb(112, 112, 112)",
      data: [0, 10, 5, 2, 20, 30, 45],
    },
    {
      label: "My second dataset",
      // backgroundColor: "rgb(31, 31, 31)",

      data: [10, 15, 5, 20, 20, 28, 42],
    },
  ],
};
 * 
 */

export function dataFormatter(inputData) {
  if (inputData == null || inputData.length === 0) return null;
  // console.log("data formatter for line chart");
  //console.log(inputData);
  const tableData = [];

  // copying score and frequecny to table data object.

  inputData.forEach((item) => {
    let obj = {};
    obj.name = item.name;
    obj.score = item.score;
    obj.frequency = item.frequency;
    obj.avgScore = item.avgScore;
    tableData.push(obj);
  });

  let numOfDays = inputData[0].data.length;
  const label = getLabel(numOfDays);
  label.reverse();

  const data = {
    labels: label,
    datasets: [],
  };

  inputData.forEach((item) => {
    const obj = {
      label: "",
      data: [],
    };

    obj.label = item.name;

    item.data.forEach((i) => {
      obj.data.push(i.count);
    });
    obj.data.reverse();
    data.datasets.push(obj);
  });

  //console.log(data);
  return { data, tableData };
}
